export default __webpack_public_path__ + "static/media/Snippets.454bf12b.txt";